import throttle from "lodash/throttle";
import sortBy from "lodash/sortBy";

$(() => {
  const reportContent = document.getElementById("report-content");
  if (reportContent === null || reportContent === undefined) return;
  const tocLinksContainer = document.getElementById("toc-links");
  const headerTagsToIncludeInToc = "h1, h2, h3";
  const headerTagsInReportContent = reportContent.querySelectorAll(
    headerTagsToIncludeInToc
  );
  const tocBackgroundColor = "#f06c00";
  let tocLinks = [];

  createToc(tocLinks, headerTagsInReportContent, tocLinksContainer);
  deepLinkScroll();
  window.addEventListener("hashchange", deepLinkScroll);
  makeH3LinksExpandable(tocLinks, tocLinksContainer);
  addLinkHighlighting(headerTagsInReportContent, tocLinks);
  makeTocToggleableForSmallScreens();
  addBackgroundColorToToc(tocLinks, tocBackgroundColor);
});

const createSlugFromText = (text, usedSlugs = {}) => {
  // Create a temporary element to extract text content
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = text;
  const plainText = tempDiv.textContent || tempDiv.innerText || "";

  // Convert to lowercase and trim
  let slug = plainText.trim().toLowerCase();

  // Replace Norwegian characters
  slug = slug
    .replace(/æ/g, "ae")
    .replace(/ø/g, "o")
    .replace(/å/g, "aa")
    .replace(/Æ/g, "ae")
    .replace(/Ø/g, "o")
    .replace(/Å/g, "aa");

  // Replace spaces and underscores with hyphens
  slug = slug.replace(/[\s_]+/g, "-");

  // Remove special characters, keep only alphanumeric and hyphens
  slug = slug.replace(/[^a-z0-9-]/g, "");

  // Remove multiple consecutive hyphens
  slug = slug.replace(/-+/g, "-");

  // Remove leading and trailing hyphens
  slug = slug.replace(/^-+|-+$/g, "");

  if (!slug) {
    slug = "section";
  }

  // Ensure uniqueness by appending a number if needed
  let uniqueSlug = slug;
  let counter = 1;
  while (usedSlugs[uniqueSlug]) {
    uniqueSlug = `${slug}-${counter}`;
    counter++;
  }
  usedSlugs[uniqueSlug] = true;

  return uniqueSlug;
};

/**
 * Loop through all header tags in the report, as defined by @const headerTagsToIncludeInToc,
 * and creates and appends an anchor-tag for each header in the toc.
 */
const createToc = (tocLinks, headerTagsInReportContent, tocLinksContainer) => {
  let currentH2Id = "";
  const usedSlugs = {}; // Track used slugs to ensure uniqueness

  for (let i = 0; i < headerTagsInReportContent.length; i++) {
    const tocLink = document.createElement("a");
    const tocLinkWrapper = document.createElement("div");
    const currentHeaderTag = headerTagsInReportContent[i];

    // Skip headers with className set, to only include normal headers created through TinyMCE
    if (currentHeaderTag.className !== "") {
      continue;
    }

    // Generate slug from header text
    const slug = createSlugFromText(currentHeaderTag.innerHTML, usedSlugs);
    let headerId = slug; 
    let tocLinkId = headerId;

    tocLink.innerHTML = currentHeaderTag.innerHTML;
    tocLink.className = "report-toc--link";
    tocLinkWrapper.className = "report-toc--link-wrapper";

    switch (currentHeaderTag.tagName) {
      case "H1":
        tocLink.className += " report-toc--link--h1";
        break;
      case "H2":
        tocLink.className += " report-toc--link--h2";
        currentH2Id = headerId;
        break;
      case "H3":
        tocLink.className += " report-toc--link--h3--hidden";
        // Initialize with H2 ID and H3 slug
        let uniqueCombinedId = `${currentH2Id}#${slug}`;
        console.log(uniqueCombinedId);
        let counter = 1;
        // Ensure uniqueness for the combined ID
        while (usedSlugs[uniqueCombinedId]) {
          uniqueCombinedId = `${currentH2Id}#${slug}-${counter}`;
          counter++;
        }
        usedSlugs[uniqueCombinedId] = true;
        headerId = uniqueCombinedId;
        // TOC link ID includes parent H2 for grouping
        tocLinkId = headerId + ":" + currentH2Id;
        break;
      default:
        tocLink.className = "report-toc--link";
        break;
    }

    currentHeaderTag.id = headerId;
    tocLink.href = "#" + headerId;
    tocLink.id = "toc-" + tocLinkId;

    tocLinkWrapper.appendChild(tocLink);
    tocLinks.push(tocLink);
    tocLinksContainer.appendChild(tocLinkWrapper);
  }
};

const deepLinkScroll = () => {
  if (!location.hash) return;
  const id = location.hash.slice(1);
  requestAnimationFrame(() => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ block: "start", behavior: "auto" });
    }
  });
};

/**
 * Loop through all links in the TOC. If there are any links to h2-titles which has sub-links to h3-titles,
 * add a toggleable arrow-icon and onClick event which toggles the corresponding h3-titles in the TOC.
 */
const makeH3LinksExpandable = (tocLinks, tocLinksContainer) => {
  const tocLinksContainerList = [...tocLinksContainer.childNodes];

  for (let i = 0; i < tocLinksContainerList.length; i++) {
    const currentLinkWrapper = tocLinksContainerList[i];
    const currentLink = currentLinkWrapper.firstChild;

    const currentLinkIsH2 = currentLink.className.includes("h2");
    const currentLinkHasSubLinks = tocLinks.some((link) => {
      const reg = new RegExp("\\b" + getIdFromTocId(currentLink.id) + "\\b");
      return link.id.search(reg) >= 0 && link.className.includes("h3");
    });

    // The TOC should hide if any links are clicked on the mobile-version, except if the link expands other sub-links
    if (!(currentLinkHasSubLinks && currentLinkIsH2)) {
      $(currentLink).on("click", () => $("#toc-links").toggle());
    }

    // If the current link is a h2-title, and it has sub-links (belonging h3-titles), add an arrow-icon, and add toggle-functionality
    if (currentLinkIsH2 && currentLinkHasSubLinks) {
      const visibleLinkClassName =
        "report-toc--link report-toc--link--h3--visible";
      const hiddenLinkClassName =
        "report-toc--link report-toc--link--h3--hidden";
      const downArrowClassName =
        "report-toc--expand report-toc--expand--down report-toc--expand--down--desktop";
      const upArrowClassName =
        "report-toc--expand report-toc--expand--up report-toc--expand--up--desktop";

      const arrowIcon = document.createElement("span");
      arrowIcon.className = downArrowClassName;
      currentLink.after(arrowIcon);

      $(currentLinkWrapper).on("click", () => {
        tocLinksContainer.childNodes.forEach((link) => {
          const linkElement = link.firstChild;
          const reg = new RegExp(
            "\\b" + getIdFromTocId(currentLink.id) + "\\b"
          );

          if (
            linkElement.className.includes("h3") &&
            linkElement.id.search(reg) >= 0
          ) {
            // Toggle visibility of h3-link
            linkElement.className = linkElement.className.includes("visible")
              ? hiddenLinkClassName
              : visibleLinkClassName;
          }
          if (
            linkElement.className.includes("h2") &&
            linkElement.id.search(reg) >= 0
          ) {
            // Toggle rotation of arrow-icon
            arrowIcon.className = arrowIcon.className.includes("down")
              ? upArrowClassName
              : downArrowClassName;
          }
        });
      });
    }
  }
};

/**
 * Create an onScroll event which is throttled by lodash's 'throttle'-package,
 * at an interval set by @const delayForOnScrollEventInMs.
 * The function collects all header tags in the report, finds the one which is
 * located closest to the top of the user's viewport, and then highlights the
 * matching link in the toc.
 */
const addLinkHighlighting = (headerTagsInReportContent, tocLinks) => {
  const delayForOnScrollEventInMs = 300;

  $(window).on(
    "scroll",
    throttle(() => {
      const headerTagsArray = Array.from(headerTagsInReportContent);

      const headerTagClosestToTopOfViewport = sortBy(headerTagsArray, (tag) =>
        Math.abs(tag.getBoundingClientRect().top - 0)
      )[0];

      // Extract hash from href (handles both relative "#id" and absolute "url#id")
      const getHashFromHref = (href) => {
        const hashIndex = href.indexOf("#");
        return hashIndex >= 0 ? href.substring(hashIndex + 1) : "";
      };

      let chapterLinkToHighlight = tocLinks.find(
        (link) =>
          getHashFromHref(link.href) === headerTagClosestToTopOfViewport.id
      );

      if (chapterLinkToHighlight) {
        // If a toc-link which is hidden should be highlighted, highlight it's parent toc-link instead.
        if (chapterLinkToHighlight.className.includes("hidden")) {
          chapterLinkToHighlight = tocLinks.find(
            (link) =>
              getHashFromHref(link.href) === headerTagClosestToTopOfViewport.id
          );
        }

        tocLinks.forEach((link) => (link.style = ""));
        chapterLinkToHighlight.style = "color: #f06c00;";
      }
    }, delayForOnScrollEventInMs)
  );
};

/**
 * Creates an onClick event for the toc container which is shown for
 * 'md' and lower media sizes. Toggles the toc list.
 */
const makeTocToggleableForSmallScreens = () => {
  $("#report-toc--title-container").on("click", () => {
    $("#toc-links").toggle();
  });
};

const addBackgroundColorToToc = (tocLinks, colorHex) => {
  tocLinks[0].style = `color: ${colorHex};`;
};

/**
 * The links in the TOC has ids which corresponds to the ids of the titles in the report.
 * To differentiate them, the links in the TOC follows the convention: 'toc-{id}'.
 * This utility function simply extracts the id-part, which is used for comparrisons.
 */
const getIdFromTocId = (id) => {
  if (id.startsWith("toc-")) {
    return id.substring(4); // Remove "toc-" prefix
  }
  return id;
};